import React, { useState, useEffect } from "react";
import { PROGRAMS } from "../data/config";

// ── PROGRAM DETAILS ──────────────────────────────────────────
// Edit program names, descriptions, and details here.
// Icons use emoji — replace with your own or use SVG.
const PROGRAM_DETAILS = [
  {
    id: "gradshpe",
    name: "GradSHPE",
    icon: "🎓",
    tagline: "For Graduate Students in STEM",
    color: "#1A4A7A",
    description:
      "GradSHPE is a community for graduate students navigating the unique challenges of advanced degrees in STEM. We provide resources, networking, and a support system for master's and PhD students.",
    // UPDATE: add bullet point highlights
    highlights: [
      "Research networking events",
      "Graduate school application workshops",
      "PhD student community meetups",
      "Industry vs academia career panels",
    ],
    // UPDATE: contact or lead name for this program
    lead: "Contact shpevt@gmail.com",
  },
  {
    id: "shpetinas",
    name: "SHPEtinas",
    icon: "⭐",
    tagline: "Empowering Latinas in STEM",
    color: "#861F41",
    description:
      "SHPEtinas is a sisterhood within SHPE dedicated to empowering Latina women in STEM. Through mentorship, leadership development, and community, we cultivate the next generation of Latina engineers and scientists.",
    highlights: [
      "Mentorship circles and one-on-ones",
      "Professional development workshops",
      "Latina leadership spotlights",
      "Networking with Latina professionals",
    ],
    lead: "Contact shpevt@gmail.com",
  },
  {
    id: "outreach",
    name: "Outreach",
    icon: "🌱",
    tagline: "Inspiring the Next Generation",
    color: "#2D7A4F",
    description:
      "Our outreach initiatives inspire younger students to pursue STEM careers by providing hands-on activities, mentorship, and representation. Through partnerships with local schools and organizations, we work to close the opportunity gap in engineering and science.",
    highlights: [
      "K-12 school STEM visits",
      "Hands-on engineering activities",
      "Science fair mentorship",
      "Local community partnerships",
    ],
    lead: "Contact shpevt@gmail.com",
  },
  {
    id: "mentorshpe",
    name: "MentorSHPE",
    icon: "🤝",
    tagline: "Peer Mentorship Program",
    color: "#C8922A",
    description:
      "MentorSHPE connects underclassmen with upperclassmen mentors who provide academic support, career advice, and guidance through college life. Building bridges between students at all levels.",
    highlights: [
      "One-on-one mentor matching",
      "Study groups and tutoring",
      "Resume and internship guidance",
      "Academic check-ins each semester",
    ],
    lead: "Contact shpevt@gmail.com",
  },
];

export default function Programs() {
  const [active, setActive] = useState(0);
  const prog = PROGRAM_DETAILS[active];
  useEffect(() => {
    const handleSwitch = (e) => {
      const idx = PROGRAM_DETAILS.findIndex((p) => p.id === e.detail);
      if (idx !== -1) setActive(idx);
    };
    window.addEventListener("switchProgram", handleSwitch);
    return () => window.removeEventListener("switchProgram", handleSwitch);
  }, []);

  return (
    <section
      id="programs"
      style={{ padding: "80px 24px", background: "#0D0D0D" }}
    >
      <div style={{ maxWidth: 1200, margin: "0 auto" }}>
        <div className="section-header">
          <span className="section-label">Programs</span>
          <h2 className="section-title" style={{ color: "white" }}>
            Ut Prosim — That I May Serve
          </h2>
          <p className="section-subtitle">
            Our programs extend SHPE's mission beyond our membership, serving
            the broader community.
          </p>
        </div>

        {/* Tab Selector */}
        <div
          style={{
            display: "flex",
            gap: 8,
            flexWrap: "wrap",
            justifyContent: "center",
            marginBottom: 40,
          }}
        >
          {PROGRAM_DETAILS.map((p, i) => (
            <button
              key={p.id}
              onClick={() => setActive(i)}
              style={{
                padding: "10px 22px",
                borderRadius: 100,
                fontSize: 14,
                fontWeight: 600,
                background: active === i ? p.color : "rgba(255,255,255,0.08)",
                color: active === i ? "white" : "rgba(255,255,255,0.6)",
                border: `2px solid ${active === i ? p.color : "transparent"}`,
                transition: "all 0.25s ease",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: 8,
              }}
            >
              <span>{p.icon}</span> {p.name}
            </button>
          ))}
        </div>

        {/* Active Program Detail */}
        <div
          style={{
            background: "rgba(255,255,255,0.05)",
            border: `1px solid ${prog.color}40`,
            borderRadius: 20,
            padding: "48px",
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: 48,
            alignItems: "center",
            transition: "border-color 0.3s ease",
          }}
          className="program-detail-grid"
        >
          <div>
            <div
              style={{
                width: 64,
                height: 64,
                borderRadius: 16,
                background: `${prog.color}25`,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 30,
                marginBottom: 20,
              }}
            >
              {prog.icon}
            </div>
            <span
              style={{
                fontSize: 12,
                fontWeight: 700,
                letterSpacing: 2,
                textTransform: "uppercase",
                color: prog.color,
              }}
            >
              {prog.tagline}
            </span>
            <h3
              style={{
                fontFamily: "Playfair Display, serif",
                fontSize: "clamp(1.8rem, 3vw, 2.5rem)",
                fontWeight: 900,
                color: "white",
                marginTop: 8,
                marginBottom: 16,
              }}
            >
              {prog.name}
            </h3>
            <p
              style={{
                color: "rgba(255,255,255,0.75)",
                lineHeight: 1.8,
                fontSize: 15,
              }}
            >
              {prog.description}
            </p>
            <div style={{ marginTop: 24 }}>
              <a
                href={`mailto:shpevt@gmail.com`}
                className="btn"
                style={{
                  background: prog.color,
                  color: "white",
                  padding: "12px 24px",
                  fontSize: 14,
                }}
              >
                Get Involved →
              </a>
            </div>
          </div>

          <div>
            <h4
              style={{
                color: "rgba(255,255,255,0.5)",
                fontSize: 12,
                letterSpacing: 2,
                textTransform: "uppercase",
                marginBottom: 20,
              }}
            >
              What We Offer
            </h4>
            <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
              {prog.highlights.map((item, i) => (
                <div
                  key={i}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 14,
                    padding: "14px 18px",
                    background: "rgba(255,255,255,0.06)",
                    borderRadius: 10,
                    border: "1px solid rgba(255,255,255,0.08)",
                  }}
                >
                  <span
                    style={{
                      width: 8,
                      height: 8,
                      borderRadius: "50%",
                      background: prog.color,
                      flexShrink: 0,
                    }}
                  />
                  <span
                    style={{ color: "rgba(255,255,255,0.85)", fontSize: 14 }}
                  >
                    {item}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) {
          .program-detail-grid { grid-template-columns: 1fr !important; padding: 28px !important; }
        }
      `}</style>
    </section>
  );
}
